import type { AuthSessionFailure } from './authSession.ts'

export const AUTH_REQUIRED_EVENT = 'pulse:auth-required'

export type AuthRequiredStatus = 401 | 403
export type AuthRequiredSource = 'http' | 'websocket'

export type AuthRequiredEventDetail = {
  status: AuthRequiredStatus | null
  source: AuthRequiredSource
  failure?: AuthSessionFailure
}

export function authRequiredStatus(status: number): AuthRequiredStatus | null {
  return status === 401 || status === 403 ? status : null
}

export function broadcastAuthRequired(
  status: number,
  source: AuthRequiredSource
): boolean {
  const normalized = authRequiredStatus(status)
  if (!normalized || typeof window === 'undefined') return false
  window.dispatchEvent(new CustomEvent<AuthRequiredEventDetail>(AUTH_REQUIRED_EVENT, {
    detail: { status: normalized, source }
  }))
  return true
}

export function broadcastAuthSessionFailure(
  failure: AuthSessionFailure,
  source: AuthRequiredSource
): boolean {
  if (typeof window === 'undefined') return false
  const status = failure.status === 401 || failure.status === 403
    ? failure.status
    : null
  window.dispatchEvent(new CustomEvent<AuthRequiredEventDetail>(AUTH_REQUIRED_EVENT, {
    detail: { status, source, failure }
  }))
  return true
}
